import { render, staticRenderFns } from "./DraftPostingLifecycle.vue?vue&type=template&id=3ad125e4"
import script from "./DraftPostingLifecycle.vue?vue&type=script&lang=js"
export * from "./DraftPostingLifecycle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports